import React from 'react';
import SharedLeftPanel from '../Shared/SharedLeftPanel';
import { TRIGGER_TYPE } from '../..';

const CodeLeftPanel = ({ TriggerByCodeType, selection , setSelection }) =>(
  <SharedLeftPanel items={TriggerByCodeType} selection={selection} setSelection={setSelection} triggerType={TRIGGER_TYPE.TRIGGER_BY_CODE}/>
);


export default CodeLeftPanel;